/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleDataAccessCustom } from '../../models/role-data-access-custom';

export interface GetRoleDataAccessByRole$Params {
  arid: number;
}

export function getRoleDataAccessByRole(http: HttpClient, rootUrl: string, params: GetRoleDataAccessByRole$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDataAccessCustom>> {
  const rb = new RequestBuilder(rootUrl, getRoleDataAccessByRole.PATH, 'get');
  if (params) {
    rb.path('arid', params.arid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleDataAccessCustom>;
    })
  );
}

getRoleDataAccessByRole.PATH = '/api/AclRole/roleDataByArid/{arid}';
